const normalizeStringValue = (value) =>
  // Better than regex :)
  // Use this replace instead of .replace(/\p{Diacritic}/gu, '') because
  // "/\p{Diacritic}/gu" doesnt work properly without latest version of Microsoft Edge.
  value
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase();
export default normalizeStringValue;
